import { LogOut, KeyRound } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { navForRole, ROLE_LABEL } from "@/lib/roles";

export default function Sidebar({ active, onChange, badges = {}, onChangePassword }) {
  const { user, logout } = useAuth();
  const role = user?.role || "admin";
  return (
    <aside className="no-print hidden md:flex w-64 shrink-0 flex-col bg-[#0F172A] text-slate-300 min-h-screen sticky top-0">
      <div className="flex items-center gap-3 px-6 h-20 border-b border-white/10">
        <Logo testid="sidebar-logo" />
        <div>
          <div className="font-head font-bold text-white text-lg leading-none">Shri Ji Clinic</div>
          <div className="text-[11px] text-slate-400 mt-1" data-testid="sidebar-role-label">{ROLE_LABEL[role]}</div>
        </div>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1">
        {navForRole(role).map((item) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          const count = badges[item.key] || 0;
          return (
            <button key={item.key} data-testid={`nav-${item.key}`} onClick={() => onChange(item.key)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-teal-600 text-white" : "hover:bg-white/5 text-slate-300"}`}>
              <Icon className="h-[18px] w-[18px]" />
              {item.label}
              {count > 0 && (
                <span data-testid={`nav-badge-${item.key}`} className="ml-auto bg-amber-500 text-white text-xs font-semibold rounded-full px-2 py-0.5 min-w-[20px] text-center">{count}</span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-white/10">
        <div className="flex items-center gap-3 px-2 py-2 mb-2">
          <div className="h-9 w-9 rounded-full bg-teal-500/20 text-teal-300 flex items-center justify-center font-semibold uppercase">{(user?.name || user?.email || "A")[0]}</div>
          <div className="min-w-0">
            <div className="text-sm font-medium text-white truncate" data-testid="sidebar-user-name">{user?.name || "Admin"}</div>
            <div className="text-[11px] text-slate-400 truncate">{user?.email}</div>
          </div>
        </div>
        <button data-testid="change-password-button" onClick={onChangePassword} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-slate-300 hover:bg-white/5">
          <KeyRound className="h-[18px] w-[18px]" /> Change Password
        </button>
        <button data-testid="logout-button" onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-slate-300 hover:bg-white/5">
          <LogOut className="h-[18px] w-[18px]" /> Logout
        </button>
      </div>
    </aside>
  );
}
